import {
  endOfMonth,
  endOfYear,
  startOfMonth,
  startOfYear,
  sub,
} from "date-fns";

import { formatDateForApi, newDateWithCurrentTimezone } from "@/utils";
import { msg } from "@lingui/core/macro";
import { MessageDescriptor } from "@lingui/core";

const TODAY = new Date();

const ALL_RESULTS_START_DATE_FALLBACK = new Date(2000, 0, 1);

type DateRange = {
  startDate: Date;
  endDate: Date;
  label: MessageDescriptor;
  identifier: string;
  default?: boolean;
};

export const getMentionViewDateRanges = (
  searchStartDate?: string
): DateRange[] => [
  {
    startDate: searchStartDate
      ? newDateWithCurrentTimezone(searchStartDate)
      : ALL_RESULTS_START_DATE_FALLBACK,
    endDate: TODAY,
    label: msg`Alla träffar`,
    identifier: "all_results",
  },
  {
    startDate: sub(TODAY, { hours: 24 }),
    endDate: TODAY,
    label: msg`Senaste dygnet`,
    identifier: "last_24_hours",
  },
  {
    startDate: sub(TODAY, { days: 7 }),
    endDate: TODAY,
    label: msg`Senaste 7 dagarna`,
    identifier: "last_7_days",
  },
  {
    startDate: sub(TODAY, { days: 30 }),
    endDate: TODAY,
    label: msg`Senaste 30 dagarna`,
    identifier: "last_30_days",
  },
  {
    startDate: sub(TODAY, { months: 3 }),
    endDate: TODAY,
    default: true,
    label: msg`Senaste 3 månader`,
    identifier: "last_3_months",
  },
  {
    startDate: startOfMonth(TODAY),
    endDate: TODAY,
    label: msg`Denna månad`,
    identifier: "this_month",
  },
  {
    startDate: startOfMonth(sub(TODAY, { months: 1 })),
    endDate: endOfMonth(sub(TODAY, { months: 1 })),
    label: msg`Föregående månad`,
    identifier: "previous_month",
  },
  {
    startDate: startOfYear(TODAY),
    endDate: TODAY,
    label: msg`Detta året`,
    identifier: "this_year",
  },
  {
    startDate: startOfYear(sub(TODAY, { years: 1 })),
    endDate: endOfYear(sub(TODAY, { years: 1 })),
    label: msg`Föregående år`,
    identifier: "previous_year",
  },
];

export function getDateRange(
  startDate: string | undefined,
  endDate: string | undefined,
  dateRanges: DateRange[]
) {
  if (!startDate || !endDate) {
    return undefined;
  }

  return dateRanges.find(
    (r) =>
      formatDateForApi(r.startDate) === startDate &&
      formatDateForApi(r.endDate) === endDate
  );
}
